'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * Card
 *
 * React component used to display information in a box-ed in card-like layout.
 */
var Card = react.forwardRef(function (props, ref) {
  var rest = react.omitThemingProps(props);
  var styles = react.useMultiStyleConfig('Card', props);
  return /*#__PURE__*/React__namespace.createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__namespace.createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-card', props.className),
    __css: styles.card
  })));
});
Card.displayName = 'Card';
exports.Card = Card;